import React from "react";

const ChangeOfParticularsIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <ellipse
        cx="10"
        cy="10"
        rx="10"
        ry="10"
        transform="rotate(90 10 10)"
        fill="white"
      />
      <ellipse
        cx="9.98465"
        cy="9.83225"
        rx="8.88889"
        ry="8.88889"
        transform="rotate(90 9.98465 9.83225)"
        fill="#FDBF02"
        fill-opacity="0.1"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.9909 7.68893C11.0794 7.60047 11.1994 7.55078 11.3245 7.55078C11.4496 7.55078 11.5696 7.60047 11.6581 7.68893L13.5454 9.57629C13.6339 9.66477 13.6836 9.78476 13.6836 9.90988C13.6836 10.035 13.6339 10.155 13.5454 10.2435L11.6581 12.1308C11.5691 12.2168 11.4499 12.2643 11.3262 12.2633C11.2025 12.2622 11.0841 12.2126 10.9967 12.1251C10.9092 12.0376 10.8596 11.9192 10.8585 11.7955C10.8574 11.6718 10.905 11.5526 10.9909 11.4636L12.0728 10.3817L6.60611 10.3817C6.48097 10.3817 6.36096 10.332 6.27247 10.2435C6.18398 10.155 6.13427 10.035 6.13427 9.90988C6.13427 9.78474 6.18398 9.66472 6.27247 9.57623C6.36096 9.48775 6.48097 9.43804 6.60611 9.43804L12.0728 9.43804L10.9909 8.35611C10.9025 8.26763 10.8528 8.14763 10.8528 8.02252C10.8528 7.8974 10.9025 7.77741 10.9909 7.68893Z"
        fill="#FDBF02"
        //fill-opacity="0.5"
      />
    </svg>
  );
};

export default ChangeOfParticularsIcon;
